module.exports = __webpack_public_path__ + "static/media/co_error_icon.3fe136ca.svg";